import React, { useEffect, useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { checkHttpStatus, post } from '../../utils/RestUtilsWithAxios';
import { fetchDownload } from '../../utils/RestUtils';
import { GET_KAP_ATTACHMENT, SAVE_KAP_DECLARATION } from '../../constants/uri';
import * as Globals from '../../constants/globals';
import { Formik } from 'formik';
import Paper from '@material-ui/core/es/Paper/Paper';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { alertBox } from '../../components/BoxProvider';
import Dropdown from '../../components/Dropdown';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { TextField } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@material-ui/core';
import NumberFormat from 'react-number-format';
import InlineDisclosureTable, {
    PAY_DISI_COLUMNS,
    areRowsComplete,
} from './InlineDisclosureTable';

const bigdecimal = require('bigdecimal');

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    paper: {
        marginBottom: theme.spacing(2),
        margin: 'auto',
        padding: 30,
        paddingTop: 20,
    },
    formControl: {
        marginTop: theme.spacing(2),
        minWidth: 120,
    },
    overflowX: {
        overflowX: 'auto',
    },
    tableWrapper: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
    titleGutter: {
        marginBottom: theme.spacing(1),
    },
    divider: {
        width: '100%',
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
    showButton: {
        [theme.breakpoints.up('xs')]: {
            width: 200,
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    fontBold: {
        fontWeight: 600,
    },
    fontLight: {
        fontWeight: 'lighter',
    },
    thinBox: {
        padding: 16,
        borderRadius: 4,
        borderWidth: 2,
        borderStyle: 'solid',
    },
    typography: {
        fontSize: 12,
    },
    closeBtn: {
        position: 'absolute',
        right: 12,
        top: 12,
        color: '#9a9a9e',
    },
}));

const headStyles = makeStyles(() => ({
    headFont: {
        fontSize: 12,
        fontWeight: 600,
    },
}));

function EnhancedTableHead() {
    const headClasses = headStyles();

    const headRows = [
        {
            id: 'col1',
            numeric: false,
            disablePadding: false,
            label: 'İşlem Tarihi',
        },
        {
            id: 'col2',
            numeric: false,
            disablePadding: false,
            label: 'İşlem Niteliği',
        },
        {
            id: 'col3',
            numeric: false,
            disablePadding: false,
            label: 'Sermaye Piyasası Aracının ISIN Kodu',
        },
        {
            id: 'col4',
            numeric: true,
            disablePadding: false,
            label: 'İşleme Konu Sermaye Piyasası Aracının Nominal Tutarı (TL)',
        },
        {
            id: 'col5',
            numeric: true,
            disablePadding: false,
            label: 'İşleme Konu Sermaye Piyasası Aracı Adedi',
        },
        {
            id: 'col6',
            numeric: true,
            disablePadding: false,
            label: 'İşlem Fiyatı (TL)',
        },
        {
            id: 'col7',
            numeric: true,
            disablePadding: false,
            label: 'İşlem Tutarı (TL)',
        },
        {
            id: 'col8',
            numeric: true,
            disablePadding: false,
            label: 'İşlem Öncesi Sahip Olunan Nominal Tutar (TL)',
        },
        {
            id: 'col9',
            numeric: true,
            disablePadding: false,
            label: 'İşlem Sonrası Sahip Olunan Nominal Tutar (TL)',
        },
    ];

    return (
        <TableHead>
            <TableRow>
                {headRows.map(row => (
                    <TableCell
                        key={row.id}
                        align={row.numeric ? 'right' : 'left'}
                        padding={row.disablePadding ? 'none' : 'default'}
                        className={headClasses.headFont}
                    >
                        {row.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

function PayDisi(props) {
    const classes = useStyles();
    const theme = useTheme();

    const isMounted = useRef(true);
    const timerRef = useRef(null);
    const resetFormRef = useRef(null);

    const [currentTime, setCurrentTime] = useState('');
    const [loading, setLoading] = useState(false);
    const [companyTitle, setCompanyTitle] = useState('');
    const [nameOrTitle, setNameOrTitle] = useState('');
    const [toplamAlis1, setToplamAlis1] = useState('0');
    const [toplamAlis2, setToplamAlis2] = useState('0');
    const [toplamSatis1, setToplamSatis1] = useState('0');
    const [toplamSatis2, setToplamSatis2] = useState('0');
    const [tableItems, setTableItems] = useState([]);
    const [successDeclarationId, setSuccessDeclarationId] = useState('');
    const [openForPreview, setOpenForPreview] = useState(false);
    const [openForDocument, setOpenForDocument] = useState(false);
    const [openForClear, setOpenForClear] = useState(false);
    const [checked, setChecked] = useState(false);

    const correctionList = [
        { value: 'Y', label: 'EVET' },
        { value: 'N', label: 'HAYIR' },
    ];

    const charLimitWarning1 =
        "Bu alana maksimum 300 karakter girişi yapılmalıdır. Daha fazla karakter içeren bir metin girişi veya kopyalama yapıldığında MKK'ya gönderilen pdf dosya sadece 300 karakterlik bölümü içerecek şekilde oluşturulur. Bildirimin eksik bilgi içermemesi açısından bu hususun dikkate alınması gerekmektedir.";

    const charLimitWarning2 =
        "Bu alana maksimum 1600 karakter girişi yapılmalıdır. Daha fazla karakter içeren bir metin girişi veya kopyalama yapıldığında MKK'ya gönderilen pdf dosya sadece 1600 karakterlik bölümü içerecek şekilde oluşturulur. Bildirimin eksik bilgi içermemesi açısından bu hususun dikkate alınması gerekmektedir.";

    const investorType = localStorage.getItem('InvestorType');

    const initialDeclaration =
        '........... tarihinde ........ TL fiyattan toplam ................ adet özel sektör tahvili/banka bonosu/...... alış/satış işlemi tarafımızca gerçekleştirilmiştir. İşlemin detaylarına ilişkin bilgiler aşağıdaki tabloda verilmektedir.';

    const [values, setValues] = useState({
        eyatUserId: props.myselfId,
        subject: '',
        correction: correctionList[1].value,
        nameAndSurname: '',
        tuzelName: '',
        gorev: '',
        otherNames: '',
        declaration: initialDeclaration,
    });

    useEffect(() => {
        return () => {
            isMounted.current = false;

            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, []);

    useEffect(() => {
        setNameOrTitle(localStorage.getItem('NameSurname') || '');
    }, []);

    useEffect(() => {
        if (props.myselfId && values.eyatUserId !== props.myselfId) {
            setValues(prev => ({
                ...prev,
                eyatUserId: props.myselfId,
            }));
        }
    }, [props.myselfId]);

    useEffect(() => {
        if (props.bildirimContext?.company && props.companies) {
            const found = props.companies.find(
                company => company.value === props.bildirimContext.company
            );

            if (found) {
                setCompanyTitle(found.label);
            }
        }
    }, [props.bildirimContext, props.companies]);

    useEffect(() => {
        handleToplamlar(tableItems);
    }, [tableItems]);

    function formatDate(date) {
        if (!date || typeof date !== 'string' || date.length < 8) {
            return '';
        }

        return (
            date.substring(6) +
            '/' +
            date.substring(4, 6) +
            '/' +
            date.substring(0, 4)
        );
    }

    function formatDecimal(num) {
        if (num == null || num === 'NaN' || num === '') {
            return '';
        }

        const str = num.toString();

        if (str.includes('.')) {
            return (
                str
                    .split('.')[0]
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') +
                ',' +
                str.split('.')[1]
            );
        }

        return str.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    }

    function handleToplamlar(rows) {
        if (!rows || rows.length === 0) {
            setToplamAlis1('0');
            setToplamAlis2('0');
            setToplamSatis1('0');
            setToplamSatis2('0');
            return;
        }

        let ta1 = new bigdecimal.BigDecimal('0');
        let ta2 = new bigdecimal.BigDecimal('0');
        let ts1 = new bigdecimal.BigDecimal('0');
        let ts2 = new bigdecimal.BigDecimal('0');

        const cleanNum = value => {
            if (
                value === null ||
                value === undefined ||
                value === '' ||
                value === 'NaN'
            ) {
                return new bigdecimal.BigDecimal('0');
            }

            const str = String(value).trim();

            let normalized;
            if (str.includes(',')) {
                normalized = str.replace(/\./g, '').replace(',', '.');
            } else {
                normalized = str;
            }

            if (normalized.trim() === '' || isNaN(Number(normalized))) {
                return new bigdecimal.BigDecimal('0');
            }

            return new bigdecimal.BigDecimal(normalized);
        };

        rows.forEach(row => {
            const nominal = cleanNum(row.nominalTutar);
            const tutar = cleanNum(row.islemTutari);

            if (row.islemNiteligi === 'Alım') {
                ta1 = ta1.add(nominal);
                ta2 = ta2.add(tutar);
            } else if (row.islemNiteligi === 'Satım') {
                ts1 = ts1.add(nominal);
                ts2 = ts2.add(tutar);
            }
        });

        setToplamAlis1(formatDecimal(ta1.toString()));
        setToplamAlis2(formatDecimal(ta2.toString()));
        setToplamSatis1(formatDecimal(ts1.toString()));
        setToplamSatis2(formatDecimal(ts2.toString()));
    }

    function formatTableItems(table) {
        if (!table || table.length === 0) {
            return [];
        }

        return table.map(row => ({
            islemTarihi: formatDate(row.islemTarihi),
            islemNiteligi: row.islemNiteligi || '',
            isinCode: row.isinCode || '',
            nominalTutar: formatDecimal(row.nominalTutar),
            sermayePiyasasiAdedi: formatDecimal(row.sermayePiyasasiAdedi),
            islemFiyati: formatDecimal(row.islemFiyati),
            islemTutari: formatDecimal(row.islemTutari),
            islemdenOnceNominalTutar: formatDecimal(
                row.islemdenOnceNominalTutar
            ),
            islemdenSonraNominalTutar: formatDecimal(
                row.islemdenSonraNominalTutar
            ),
        }));
    }

    function openModal2() {
        if (
            tableItems.length > 0 &&
            !areRowsComplete(tableItems, PAY_DISI_COLUMNS)
        ) {
            alertBox(
                '',
                'Tabloda doldurulmamış alan(lar) bulunmaktadır. Lütfen tüm alanları doldurunuz.',
                Globals.ALERT_WARNING,
                props.intl
            );

            return;
        }

        setOpenForPreview(true);

        if (timerRef.current) {
            clearInterval(timerRef.current);
        }

        const updateTime = () => {
            if (!isMounted.current) {
                return;
            }

            const time = new Date();

            setCurrentTime(
                time.getDate().toString().padStart(2, '0') +
                    '/' +
                    (time.getMonth() + 1).toString().padStart(2, '0') +
                    '/' +
                    time.getFullYear().toString() +
                    ' ' +
                    time.getHours().toString().padStart(2, '0') +
                    ':' +
                    time.getMinutes().toString().padStart(2, '0') +
                    ':' +
                    time.getSeconds().toString().padStart(2, '0')
            );
        };

        updateTime();

        timerRef.current = setInterval(updateTime, 1000);
    }

    function closeForPreview() {
        setOpenForPreview(false);
        setChecked(false);

        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
    }

    function closeForDocument() {
        clearAllStates();
        props.resetWarningDialog();
    }

    function handleClose2(isOk) {
        if (isOk) {
            if (checked) {
                sendDisclosure();
            } else {
                alertBox(
                    '',
                    props.intl.formatMessage({
                        id: 'KAP_DISCLOSURE.ALERTBOX.FILL_CHECKBOX_MESSAGE',
                    }),
                    Globals.ALERT_WARNING,
                    props.intl
                );
            }
        } else {
            closeForPreview();
        }
    }

    function handleClose3() {
        downloadFile(
            successDeclarationId,
            'Bildirim_' + successDeclarationId + '.pdf'
        );

        clearAllStates();
        props.resetWarningDialog();
    }

    function downloadFile(fileOid, fileName) {
        fetchDownload(GET_KAP_ATTACHMENT + fileOid, fileName);
    }

    function clearAllStates() {
        const newValues = {
            eyatUserId: props.myselfId,
            subject: '',
            correction: correctionList[1].value,
            nameAndSurname: '',
            tuzelName: '',
            gorev: '',
            otherNames: '',
            declaration: initialDeclaration,
        };

        setValues(newValues);
        setTableItems([]);
        setToplamAlis1('0');
        setToplamAlis2('0');
        setToplamSatis1('0');
        setToplamSatis2('0');
        setSuccessDeclarationId('');
        setChecked(false);
        setCompanyTitle('');
        setCurrentTime('');
        setLoading(false);
        setNameOrTitle(localStorage.getItem('NameSurname') || '');
        setOpenForPreview(false);
        setOpenForDocument(false);

        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }

        if (resetFormRef.current) {
            resetFormRef.current({
                values: newValues,
            });
        }
    }

    function resetAllState() {
        if (!isMounted.current) {
            return;
        }

        clearAllStates();
    }

    const clearForm = showAlert => {
        resetAllState();
        setOpenForClear(false);

        if (showAlert) {
            alertBox(
                '',
                props.intl.formatMessage({
                    id: 'KAP_DISCLOSURE.ALERTBOX.FORM_CLEARED',
                }),
                Globals.ALERT_SUCCESS,
                props.intl
            );
        }
    };

    function sendDisclosure() {
        setLoading(true);

        const postData = {
            templateNo: 2,
            member: companyTitle,
            memberId: props.bildirimContext?.company || '',
            isCorrection: values.correction,
            corporateRep: values.tuzelName,
            otherActors: values.otherNames,
            declerationText: values.declaration,
            position: values.gorev,
            subject: values.subject,
            principalEyatUserId: values.eyatUserId,
            isAttorney: values.eyatUserId !== props.myselfId,
            toplamAlis1,
            toplamAlis2,
            toplamSatis1,
            toplamSatis2,
            tableItems02: formatTableItems(tableItems),
            scopeType: props.bildirimContext?.scope || '',
            scopeRole: props.bildirimContext?.role || '',
            relatedPersonName: props.bildirimContext?.relatedName || '',
            relatedPersonRelation:
                props.bildirimContext?.relatedRelation || '',
            votingRightsInfo: props.bildirimContext?.madde12Info || '',
            legalBasisText: props.bildirimContext?.legalBasis || '',
        };

        post(SAVE_KAP_DECLARATION, postData)
            .then(response => {
                if (isMounted.current) {
                    setSuccessDeclarationId(response.data);
                    closeForPreview();
                    setOpenForDocument(true);
                    setLoading(false);
                }
            })
            .catch(error => {
                if (isMounted.current) {
                    checkHttpStatus(error, props.intl, true);
                    setLoading(false);
                }
            });

        setChecked(false);
    }

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <Formik
                    enableReinitialize
                    validateOnBlur={false}
                    validateOnChange={false}
                    initialValues={values}
                    validate={formikValues => {
                        const errors = {};
                        let errorControl = false;

                        if (!formikValues.eyatUserId) {
                            setNameOrTitle('');
                            errorControl = true;

                            errors.eyatUserId = props.intl.formatMessage({
                                id: 'AUTH.VALIDATION.REQUIRED_FIELD',
                            });
                        } else if (
                            formikValues.eyatUserId === props.myselfId
                        ) {
                            setNameOrTitle(
                                localStorage.getItem('NameSurname') || ''
                            );
                        } else {
                            const attorney = props.attorneys.find(
                                item =>
                                    item.value === formikValues.eyatUserId
                            );

                            if (attorney) {
                                setNameOrTitle(
                                    attorney.label.split(' adına ')[0]
                                );
                            }
                        }

                        if (
                            !formikValues.declaration ||
                            !formikValues.declaration.trim()
                        ) {
                            errorControl = true;

                            errors.declaration =
                                props.intl.formatMessage({
                                    id: 'AUTH.VALIDATION.REQUIRED_FIELD',
                                });
                        }

                        if (
                            !formikValues.gorev &&
                            investorType !== 'R'
                        ) {
                            errorControl = true;

                            errors.gorev = props.intl.formatMessage({
                                id: 'AUTH.VALIDATION.REQUIRED_FIELD',
                            });
                        }

                        if (
                            !formikValues.tuzelName &&
                            investorType !== 'R'
                        ) {
                            errorControl = true;

                            errors.tuzelName =
                                props.intl.formatMessage({
                                    id: 'AUTH.VALIDATION.REQUIRED_FIELD',
                                });
                        }

                        if (errorControl) {
                            alertBox(
                                '',
                                'Hatalı / eksik bilgi girişi yaptınız. Lütfen girdiğiniz verileri kontrol ediniz!',
                                Globals.ALERT_ERROR,
                                props.intl
                            );
                        }

                        return errors;
                    }}
                    onSubmit={formikValues => {
                        /*
                         * Formik içindeki güncel değerleri component state'e
                         * aktarıyoruz. Preview ve sendDisclosure bu state'i
                         * kullanıyor.
                         */
                        setValues({
                            ...formikValues,
                        });

                        openModal2();
                    }}
                >
                    {({
                        values: formikValues,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        resetForm,
                    }) => {
                        resetFormRef.current = resetForm;

                        return (
                            <form
                                onSubmit={handleSubmit}
                                autoComplete="off"
                            >
                                <Grid container spacing={5}>
                                    <Grid
                                        item
                                        xs={12}
                                        container
                                        direction="column"
                                        justify="flex-end"
                                        style={{
                                            paddingBottom: theme.spacing(1),
                                        }}
                                    >
                                        <Grid
                                            item
                                            style={{ height: 70 }}
                                        >
                                            <Dropdown
                                                required
                                                noMargin
                                                name="eyatUserId"
                                                id="eyatUserId"
                                                title="Bildirim Yapan"
                                                items={props.attorneys}
                                                onChange={handleChange}
                                                helperText={
                                                    errors.eyatUserId
                                                }
                                                error={Boolean(
                                                    errors.eyatUserId
                                                )}
                                                containerSelectedItem={
                                                    formikValues.eyatUserId
                                                }
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        container
                                        direction="column"
                                        justify="flex-end"
                                        style={{
                                            paddingTop: theme.spacing(1),
                                            paddingBottom: theme.spacing(1),
                                        }}
                                    >
                                        <Typography
                                            classes={{
                                                h6: classes.titleGutter,
                                            }}
                                            variant="h6"
                                        >
                                            Konu
                                        </Typography>

                                        <Grid
                                            item
                                            style={{ height: 70 }}
                                        >
                                            <TextField
                                                fullWidth
                                                id="subject"
                                                name="subject"
                                                label="Konu"
                                                variant="outlined"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={
                                                    formikValues.subject ||
                                                    ''
                                                }
                                                helperText={
                                                    touched.subject &&
                                                    errors.subject
                                                }
                                                error={Boolean(
                                                    touched.subject &&
                                                        errors.subject
                                                )}
                                                InputLabelProps={{
                                                    shrink: Boolean(
                                                        formikValues.subject
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        container
                                        direction="column"
                                        justify="flex-end"
                                        style={{
                                            paddingTop: theme.spacing(1),
                                            paddingBottom: theme.spacing(1),
                                        }}
                                    >
                                        <Typography
                                            classes={{
                                                h6: classes.titleGutter,
                                            }}
                                            variant="h6"
                                        >
                                            Yapılan Açıklama Düzeltme mi?
                                        </Typography>

                                        <Grid
                                            item
                                            style={{ height: 70 }}
                                        >
                                            <Dropdown
                                                name="correction"
                                                required={false}
                                                noMargin
                                                id="correction"
                                                title="Düzeltme"
                                                items={correctionList}
                                                onChange={handleChange}
                                                error={Boolean(
                                                    errors.correction
                                                )}
                                                helperText={
                                                    errors.correction
                                                }
                                                containerSelectedItem={
                                                    formikValues.correction
                                                }
                                            />
                                        </Grid>
                                    </Grid>

                                    <Divider
                                        className={classes.divider}
                                    />

                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            paddingTop: theme.spacing(1),
                                            paddingBottom: theme.spacing(1),
                                        }}
                                    >
                                        <Typography
                                            classes={{
                                                h6: classes.titleGutter,
                                            }}
                                            variant="h6"
                                        >
                                            Kişi Bilgileri
                                        </Typography>
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            paddingTop: theme.spacing(1),
                                            paddingBottom: theme.spacing(1),
                                        }}
                                    >
                                        <TextField
                                            fullWidth
                                            id="nameAndSurname"
                                            name="nameAndSurname"
                                            label="Ad Soyad / Ticaret Ünvanı*"
                                            variant="outlined"
                                            disabled
                                            value={nameOrTitle || ''}
                                            InputLabelProps={{
                                                shrink: Boolean(
                                                    nameOrTitle
                                                ),
                                            }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        style={{
                                            paddingTop: theme.spacing(1),
                                            paddingBottom: theme.spacing(1),
                                        }}
                                    >
                                        <TextField
                                            fullWidth
                                            id="tuzelName"
                                            name="tuzelName"
                                            disabled={
                                                investorType === 'R'
                                            }
                                            label="Tüzel Kişi Adına Bildirimi Yapanın Adı Soyadı"
                                            variant="outlined"
                                            value={
                                                formikValues.tuzelName ||
                                                ''
                                            }
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            helperText={
                                                touched.tuzelName &&
                                                errors.tuzelName
                                            }
                                            error={Boolean(
                                                touched.tuzelName &&
                                                    errors.tuzelName
                                            )}
                                            InputLabelProps={{
                                                shrink: Boolean(
                                                    formikValues.tuzelName
                                                ),
                                            }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        style={{
                                            paddingTop: theme.spacing(1),
                                            paddingBottom: theme.spacing(1),
                                        }}
                                    >
                                        <TextField
                                            fullWidth
                                            id="gorev"
                                            name="gorev"
                                            label="Görevi"
                                            variant="outlined"
                                            value={
                                                formikValues.gorev || ''
                                            }
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            helperText={
                                                touched.gorev &&
                                                errors.gorev
                                            }
                                            error={Boolean(
                                                touched.gorev &&
                                                    errors.gorev
                                            )}
                                            InputLabelProps={{
                                                shrink: Boolean(
                                                    formikValues.gorev
                                                ),
                                            }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            paddingTop: theme.spacing(1),
                                            paddingBottom: theme.spacing(1),
                                        }}
                                    >
                                        <TextField
                                            fullWidth
                                            id="otherNames"
                                            name="otherNames"
                                            label="Varsa Birlikte Hareket Eden Diğer Gerçek/Tüzel Kişiler"
                                            variant="outlined"
                                            multiline
                                            rows={6}
                                            rowsMax={10}
                                            value={
                                                formikValues.otherNames ||
                                                ''
                                            }
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            helperText={
                                                touched.otherNames &&
                                                errors.otherNames
                                            }
                                            error={Boolean(
                                                touched.otherNames &&
                                                    errors.otherNames
                                            )}
                                            inputProps={{
                                                maxLength: 300,
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <Typography
                                                        variant="caption"
                                                        color={
                                                            (
                                                                formikValues.otherNames ||
                                                                ''
                                                            ).length ===
                                                            300
                                                                ? 'error'
                                                                : 'primary'
                                                        }
                                                        style={{
                                                            alignSelf:
                                                                'flex-end',
                                                        }}
                                                    >
                                                        {300 -
                                                            (
                                                                formikValues.otherNames ||
                                                                ''
                                                            ).length}
                                                        /300
                                                    </Typography>
                                                ),
                                            }}
                                            InputLabelProps={{
                                                shrink: Boolean(
                                                    formikValues.otherNames
                                                ),
                                            }}
                                        />

                                        <Typography
                                            variant="caption"
                                            className={
                                                classes.typography
                                            }
                                        >
                                            {charLimitWarning1}
                                        </Typography>
                                    </Grid>

                                    <Divider
                                        className={classes.divider}
                                    />

                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            paddingTop: theme.spacing(1),
                                            paddingBottom: theme.spacing(1),
                                        }}
                                    >
                                        <TextField
                                            fullWidth
                                            id="declaration"
                                            name="declaration"
                                            label="Bildirim Metni *"
                                            variant="outlined"
                                            multiline
                                            rows={12}
                                            rowsMax={18}
                                            value={
                                                formikValues.declaration ||
                                                ''
                                            }
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            helperText={
                                                touched.declaration &&
                                                errors.declaration
                                            }
                                            error={Boolean(
                                                touched.declaration &&
                                                    errors.declaration
                                            )}
                                            inputProps={{
                                                maxLength: 1600,
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <Typography
                                                        variant="caption"
                                                        color={
                                                            (
                                                                formikValues.declaration ||
                                                                ''
                                                            ).length ===
                                                            1600
                                                                ? 'error'
                                                                : 'primary'
                                                        }
                                                        style={{
                                                            alignSelf:
                                                                'flex-end',
                                                        }}
                                                    >
                                                        {1600 -
                                                            (
                                                                formikValues.declaration ||
                                                                ''
                                                            ).length}
                                                        /1600
                                                    </Typography>
                                                ),
                                            }}
                                            InputLabelProps={{
                                                shrink: Boolean(
                                                    formikValues.declaration
                                                ),
                                            }}
                                        />

                                        <Typography
                                            variant="caption"
                                            className={
                                                classes.typography
                                            }
                                        >
                                            {charLimitWarning2}
                                        </Typography>
                                    </Grid>
                                </Grid>

                                <div
                                    className={classes.tableWrapper}
                                >
                                    <div
                                        className={classes.overflowX}
                                    >
                                        <InlineDisclosureTable
                                            columns={
                                                PAY_DISI_COLUMNS
                                            }
                                            items={tableItems}
                                            onChange={
                                                setTableItems
                                            }
                                            addLabel="Yeni satır ekle"
                                            emptyText="Tabloda kayıt bulunmamaktadır."
                                        />
                                    </div>
                                </div>

                                <Divider
                                    className={classes.divider}
                                />

                                <Grid
                                    container
                                    justify="flex-end"
                                    spacing={2}
                                >
                                    <Grid
                                        item
                                        className={
                                            classes.showButton
                                        }
                                    >
                                        <Button
                                            type="button"
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                            fullWidth
                                            onClick={() =>
                                                setOpenForClear(true)
                                            }
                                        >
                                            FORMU TEMİZLE
                                        </Button>
                                    </Grid>

                                    <Grid
                                        item
                                        className={
                                            classes.showButton
                                        }
                                    >
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                            fullWidth
                                        >
                                            GÖNDER
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        );
                    }}
                </Formik>
            </Paper>

            <Dialog
                fullWidth
                maxWidth="lg"
                open={openForPreview}
                onClose={closeForPreview}
                aria-labelledby="preview-dialog-title"
            >
                <DialogTitle id="preview-dialog-title">
                    <Grid
                        container
                        justify="space-between"
                        alignItems="center"
                    >
                        <Typography
                            display="inline"
                            variant="h6"
                        >
                            Pay Dışındaki Sermaye Piyasası Araçlarına
                            İlişkin Bildirimler
                        </Typography>

                        <Typography
                            display="inline"
                            variant="body2"
                        >
                            {currentTime}
                        </Typography>
                    </Grid>
                </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <div>
                            <Typography
                                gutterBottom
                                variant="h6"
                                align="center"
                                style={{ color: '#800000' }}
                            >
                                SÜREKLİ BİLGİLERE İLİŞKİN ÖZEL
                                DURUM AÇIKLAMASI
                            </Typography>

                            <p>
                                <span
                                    className={classes.fontBold}
                                >
                                    Konu:{' '}
                                </span>
                                {values.subject}
                            </p>

                            <p>
                                <span
                                    className={classes.fontBold}
                                >
                                    Yapılan Açıklama Düzeltme mi?:{' '}
                                </span>

                                {values.correction === 'Y'
                                    ? 'EVET'
                                    : 'HAYIR'}
                            </p>

                            <p>
                                <span
                                    className={classes.fontBold}
                                >
                                    Bildirime Konu Borsa Şirketi:{' '}
                                </span>
                                {companyTitle}
                            </p>

                            <br />

                            <div style={{ position: 'relative' }}>
                                <div
                                    className={classes.thinBox}
                                >
                                    <p>
                                        {values.declaration || ''}
                                    </p>
                                </div>
                            </div>

                            <br />
                            <br />

                            <p>
                                <span
                                    className={classes.fontBold}
                                >
                                    Ad Soyad/Ticaret Ünvanı:
                                </span>{' '}
                                {nameOrTitle}
                            </p>

                            <p>
                                <span
                                    className={classes.fontBold}
                                >
                                    Tüzel Kişi Adına Bildirimi
                                    Yapanın Adı Soyadı:{' '}
                                </span>
                                {values.tuzelName}
                            </p>

                            <p>
                                <span
                                    className={classes.fontBold}
                                >
                                    Görevi:{' '}
                                </span>
                                {values.gorev}
                            </p>

                            <p>
                                <span
                                    className={classes.fontBold}
                                >
                                    Varsa Birlikte Hareket Eden Diğer
                                    Gerçek/Tüzel Kişiler:{' '}
                                </span>
                                {values.otherNames}
                            </p>

                            {tableItems.length > 0 ? (
                                <Table
                                    aria-labelledby="tableTitle"
                                    size="medium"
                                    style={{
                                        marginBottom: 16,
                                    }}
                                >
                                    <EnhancedTableHead />

                                    <TableBody>
                                        {tableItems.map(
                                            (row, index) => (
                                                <TableRow
                                                    hover
                                                    tabIndex={-1}
                                                    key={
                                                        'row' +
                                                        index
                                                    }
                                                >
                                                    <TableCell align="left">
                                                        {formatDate(
                                                            row.islemTarihi
                                                        )}
                                                    </TableCell>

                                                    <TableCell align="left">
                                                        {
                                                            row.islemNiteligi
                                                        }
                                                    </TableCell>

                                                    <TableCell align="left">
                                                        {
                                                            row.isinCode
                                                        }
                                                    </TableCell>

                                                    <TableCell align="right">
                                                        <NumberFormat
                                                            decimalScale={
                                                                7
                                                            }
                                                            decimalSeparator=","
                                                            thousandSeparator="."
                                                            value={
                                                                row.nominalTutar
                                                            }
                                                            displayType="text"
                                                            isNumericString
                                                        />
                                                    </TableCell>

                                                    <TableCell align="right">
                                                        <NumberFormat
                                                            decimalScale={
                                                                7
                                                            }
                                                            decimalSeparator=","
                                                            thousandSeparator="."
                                                            value={
                                                                row.sermayePiyasasiAdedi
                                                            }
                                                            displayType="text"
                                                            isNumericString
                                                        />
                                                    </TableCell>

                                                    <TableCell align="right">
                                                        <NumberFormat
                                                            decimalScale={
                                                                7
                                                            }
                                                            decimalSeparator=","
                                                            thousandSeparator="."
                                                            value={
                                                                row.islemFiyati
                                                            }
                                                            displayType="text"
                                                            isNumericString
                                                        />
                                                    </TableCell>

                                                    <TableCell align="right">
                                                        <NumberFormat
                                                            decimalScale={
                                                                7
                                                            }
                                                            decimalSeparator=","
                                                            thousandSeparator="."
                                                            value={
                                                                row.islemTutari
                                                            }
                                                            displayType="text"
                                                            isNumericString
                                                        />
                                                    </TableCell>

                                                    <TableCell align="right">
                                                        <NumberFormat
                                                            decimalScale={
                                                                7
                                                            }
                                                            decimalSeparator=","
                                                            thousandSeparator="."
                                                            value={
                                                                row.islemdenOnceNominalTutar
                                                            }
                                                            displayType="text"
                                                            isNumericString
                                                        />
                                                    </TableCell>

                                                    <TableCell align="right">
                                                        <NumberFormat
                                                            decimalScale={
                                                                7
                                                            }
                                                            decimalSeparator=","
                                                            thousandSeparator="."
                                                            value={
                                                                row.islemdenSonraNominalTutar
                                                            }
                                                            displayType="text"
                                                            isNumericString
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        )}

                                        <TableRow>
                                            <TableCell
                                                colSpan={3}
                                                className={
                                                    classes.fontBold
                                                }
                                            >
                                                TOPLAM ALIŞ:
                                            </TableCell>

                                            <TableCell
                                                align="right"
                                                className={
                                                    classes.fontBold
                                                }
                                            >
                                                {toplamAlis1}
                                            </TableCell>

                                            <TableCell
                                                align="right"
                                                colSpan={5}
                                                className={
                                                    classes.fontBold
                                                }
                                            >
                                                {toplamAlis2}
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell
                                                colSpan={3}
                                                className={
                                                    classes.fontBold
                                                }
                                            >
                                                TOPLAM SATIŞ:
                                            </TableCell>

                                            <TableCell
                                                align="right"
                                                className={
                                                    classes.fontBold
                                                }
                                            >
                                                {toplamSatis1}
                                            </TableCell>

                                            <TableCell
                                                align="right"
                                                colSpan={5}
                                                className={
                                                    classes.fontBold
                                                }
                                            >
                                                {toplamSatis2}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            ) : null}

                            {values.eyatUserId !== props.myselfId ? (
                                <p>
                                    <span
                                        className={classes.fontBold}
                                    >
                                        Bu bildirim {nameOrTitle}{' '}
                                        adına vekaleten{' '}
                                        {localStorage.getItem(
                                            'NameSurname'
                                        )}{' '}
                                        tarafından yapılmıştır.
                                    </span>
                                </p>
                            ) : null}

                            <FormControlLabel
                                style={{ marginBottom: 0 }}
                                control={
                                    <Checkbox
                                        checked={checked}
                                        onChange={() =>
                                            setChecked(
                                                previous =>
                                                    !previous
                                            )
                                        }
                                        value={checked}
                                    />
                                }
                                label={props.intl.formatMessage({
                                    id: 'KAP_DISCLOSURE.CHECKBOX.APPROVE_DISCLOSURE',
                                })}
                            />
                        </div>
                    </DialogContentText>
                </DialogContent>

                <DialogActions style={{ padding: 16 }}>
                    <Button
                        onClick={() => handleClose2(false)}
                        color="primary"
                    >
                        Vazgeç
                    </Button>

                    <Button
                        onClick={() => handleClose2(true)}
                        variant="contained"
                        color="primary"
                        disabled={loading}
                    >
                        Tamam
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                fullWidth
                maxWidth="sm"
                open={openForDocument}
                onClose={closeForDocument}
                aria-labelledby="document-dialog-title"
            >
                <DialogTitle
                    id="document-dialog-title"
                    style={{ position: 'relative' }}
                >
                    <IconButton
                        className={classes.closeBtn}
                        size="small"
                        onClick={closeForDocument}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>

                    İşlem Tamamlandı
                </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        Bildiriminiz önizlemede görüntülendiği
                        şekilde gönderilmiştir. Teyit almak için
                        <br />
                        <span className={classes.fontBold}>
                            kapdestek@mkk.com.tr
                        </span>{' '}
                        adresine e-posta gönderebilirsiniz.

                        <Typography variant="h6">
                            Bildirim No:
                            <Typography
                                variant="h6"
                                component="span"
                                classes={{
                                    h6: classes.fontLight,
                                }}
                            >
                                {' ' + successDeclarationId}
                            </Typography>
                        </Typography>
                    </DialogContentText>
                </DialogContent>

                <DialogActions style={{ padding: 16 }}>
                    <Button
                        onClick={handleClose3}
                        variant="contained"
                        color="primary"
                    >
                        BİLDİRİMİ İNDİR
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                fullWidth
                maxWidth="sm"
                open={openForClear}
                onClose={() => setOpenForClear(false)}
                aria-labelledby="clear-dialog-title"
            >
                <DialogTitle id="clear-dialog-title">
                    Formu Temizle
                </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        Girdiğiniz tüm bilgiler temizlenecektir.
                        Onaylıyor musunuz?
                    </DialogContentText>
                </DialogContent>

                <DialogActions style={{ padding: 16 }}>
                    <Button
                        onClick={() => setOpenForClear(false)}
                        color="primary"
                    >
                        VAZGEÇ
                    </Button>

                    <Button
                        onClick={() => clearForm(true)}
                        variant="contained"
                        color="primary"
                    >
                        TEMİZLE
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default injectIntl(connect(null)(PayDisi));